import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { SectionDiv, SummaryDiv } from '../TextStyle'
import { juItems } from './JointUtilizationItems'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { SectionTitle } from '@/components/enlayouts/Legal/SectionTitle'

// const sectionTitle = {
//   titleText: 'Joint Utilization',
//   subTitleText: 'Joint Utilization of Personal Information between TRIAL Group and SU-PAY Co., Ltd.',
// }
const sectionTitle = {
  children: <h2>Joint Utilization</h2>,
}

const tSummary = (
  <p>
    TRIAL Group and SU-PAY Co., Ltd. may jointly utilize the personal information in their possession within the TRIAL Group, provided that appropriate protection measures are taken, within the scope of &quot;2. Purpose of Use&quot; of the Privacy Policy as set forth below.
  </p>
)

export const JointUtilization = () => {
  return (
    <>
      <Head
        title="Joint Utilization"
        description="The privacy policy for TRIAL Holdings, Inc."
        ogp={{ type: 'article', url: 'en/legal/privacy-policy/joint-utilization/' }}
      />
      <PrivacyContainer>
        <SectionTitle {...sectionTitle} />
        {/* <SectionTitle
          color="normal"
          titleText={sectionTitle.titleText}
          subTitleText={sectionTitle.subTitleText}
        /> */}
        <Spacer h={{ pc: 70, sp: 60 }} />
        <SummaryDiv>{tSummary}</SummaryDiv>
        <Spacer h={{ pc: 46, sp: 35 }} />
        
        {juItems.map(({ children, id }, index, array) => (
          <Fragment key={`${id}${index}`}>
            <SectionDiv id={id}>{children}</SectionDiv>
            {index < array.length - 1 && <Spacer h={{ pc: 70, sp: 39 }} />}
          </Fragment>
        ))}
      </PrivacyContainer>
    </>
  )
}
JointUtilization.getLayout = (page: ReactElement) => {
  const pageTitle = {
    title: 'Legal',
    subTitle: '',
  }

  const breadCrumbs = [
    { name: 'Home', path: '/' },
    { name: 'Legal', path: '/en/legal/' },
    { name: 'Privacy Policy', path: '/en/legal/privacy-policy/' },
    { name: 'Joint Utilization', path: '' },
  ]

  return (
    <TitleLayout
      {...pageTitle}
      breadCrumbs={breadCrumbs}
      isRequiredBackground={false}
    >
      {page}
    </TitleLayout>
  )
}

const PrivacyContainer = styled.div`
  width: 1040px;
  padding-top: 62px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 68px;
  }

  #privacy7 {
    margin-top: -105px;
    padding-top: 105px;
  }

  @media screen and (max-width: 1047px) {
    #privacy7 {
      margin-top: -53px;
      padding-top: 53px;
    }
  }
`
